import { render, staticRenderFns } from "./airMarkupSchemeDialog.vue?vue&type=template&id=19a22cf4&scoped=true&"
import script from "./airMarkupSchemeDialog.vue?vue&type=script&lang=js&"
export * from "./airMarkupSchemeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a22cf4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19a22cf4')) {
      api.createRecord('19a22cf4', component.options)
    } else {
      api.reload('19a22cf4', component.options)
    }
    module.hot.accept("./airMarkupSchemeDialog.vue?vue&type=template&id=19a22cf4&scoped=true&", function () {
      api.rerender('19a22cf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/PriceAir/components/airMarkupSchemeDialog.vue"
export default component.exports